import React from 'react';
import { motion } from 'framer-motion';
import { Scale, BookOpen, ShieldCheck } from 'lucide-react';
export function RevelationSection() {
  return <section className="py-24 px-4 bg-navy-800 relative overflow-hidden" data-id="element-217">
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-gold-500/5 rounded-full blur-3xl" data-id="element-218" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-navy-700/30 rounded-full blur-3xl" data-id="element-219" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-220">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-221">
          <h2 className="text-3xl md:text-5xl font-bold text-gold-500 mb-6" data-id="element-222">
            El Secreto que el Retail Guarda Bajo Siete Llaves
          </h2>
          <p className="text-xl text-gray-300" data-id="element-223">
            La mayoría de los chilenos cree que la única forma de salir de
            deudas es ganando el Loto o contratando un abogado de un millón de
            pesos.
          </p>
        </motion.div>

        <div className="bg-navy-900 rounded-2xl p-8 md:p-12 border border-gold-500/20 shadow-2xl" data-id="element-224">
          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3,
          duration: 0.8
        }} className="space-y-8" data-id="element-225">
            <p className="text-2xl font-serif text-white text-center mb-10" data-id="element-226">
              "Tú tienes más poder de negociación hoy del que te imaginas."
            </p>

            <div className="flex flex-col md:flex-row gap-8 items-start" data-id="element-227">
              <div className="bg-navy-800 p-4 rounded-full text-gold-500 flex-shrink-0" data-id="element-228">
                <Scale size={32} data-id="element-229" />
              </div>
              <div data-id="element-230">
                <h3 className="text-xl font-bold text-white mb-3" data-id="element-231">
                  El Punto Ciego del Sistema
                </h3>
                <p className="text-gray-400 leading-relaxed" data-id="element-232">
                  Existe un punto ciego en el sistema financiero chileno. Cuando
                  dejas de jugar bajo las reglas del banco y empiezas a jugar
                  bajo las reglas de la{' '}
                  <strong data-id="element-233">
                    Ley de Protección al Consumidor y la Ley de Insolvencia
                  </strong>
                  , el banco pasa de ser el cazador a ser el que tiene miedo de
                  perderlo todo.
                </p>
              </div>
            </div>

            <div className="flex flex-col md:flex-row gap-8 items-start" data-id="element-234">
              <div className="bg-navy-800 p-4 rounded-full text-gold-500 flex-shrink-0" data-id="element-235">
                <ShieldCheck size={32} data-id="element-236" />
              </div>
              <div data-id="element-237">
                <h3 className="text-xl font-bold text-white mb-3" data-id="element-238">
                  El Blindaje de Sueldo
                </h3>
                <p className="text-gray-400 leading-relaxed" data-id="element-239">
                  Descubrí que si aplicas el "Blindaje de Sueldo" y el "Método
                  del Hachazo", puedes obligar a las multitiendas a perdonarte
                  hasta el 80% de lo que debes.
                </p>
              </div>
            </div>

            <div className="flex flex-col md:flex-row gap-8 items-start" data-id="element-240">
              <div className="bg-navy-800 p-4 rounded-full text-gold-500 flex-shrink-0" data-id="element-241">
                <BookOpen size={32} data-id="element-242" />
              </div>
              <div data-id="element-243">
                <h3 className="text-xl font-bold text-white mb-3" data-id="element-244">
                  Estrategia Legal Aplicada
                </h3>
                <p className="text-gray-400 leading-relaxed" data-id="element-245">
                  No es magia, es estrategia legal aplicada al Chile de 2025.
                  Todo documentado, paso a paso, para que cualquier persona
                  pueda aplicarlo sin jerga legal complicada.
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}